<shared-places-suggestion [enabled]="enabled" [searchTerm]="valueChangesListener$ | async" [refElem]="refElem"
    class="forms-address-autocomplete-input" (onSelected)="handleOnSelectedAddressClick($event)">
    <shared-forms-input [enableClear]="enableClear" [showHint]="showHint" [compact]="compact" [parentForm]="parentForm"
        [type]="type" [name]="name" [label]="label" [placeholder]="placeholder"
        class="forms-address-autocomplete-input__field">
    </shared-forms-input>
</shared-places-suggestion>